<template>
    <bootstrap-collapse :visible="visible">
        <b-card-text>
            <b-card-title class="h3 mb-0">Filtro de {{ objectName }}</b-card-title>
            <div class="col-lg-12" style="text-align: right;"></div>
                <b-row cols="3">
                    <b-col v-for="(part, i) in splittedServiceItems" :key="i">
                        <div v-for="(category, index) in part" :key="index">
                            <!-- <b-form-checkbox @change="selectedCategoriesChanged(category[0])">
                                <small>{{ category[0] }}</small>
                            </b-form-checkbox> -->
                            <b>{{ category[0] }}</b>

                            <b-form-checkbox v-for="(service, idx) in category[1]" :key="idx" v-model="selectedItens[service.service]" @change="selectedServicesChanged(service)" class="ml-3">
                                <small> {{ service.service }}</small>
                            </b-form-checkbox>
                        </div>
                    </b-col>
                </b-row>
        </b-card-text>
    </bootstrap-collapse>
</template>
  
<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";

export default {
    name: "filter-checkbox-service-monitor",

    props: {
        visible: { type: Boolean, default: true },

        resetFilter: { type: Boolean, default: null },

        checkboxOptionsCategories: { type: Array, default: [] },

        checkboxOptionsProducts: { type: Array, default: [] },

        serviceOptionsToPreserve: { type: Array, default: [] },

        objectName: { type: String, default: 'serviços' },
    },

    components: {
        BootstrapCollapse,
        [Select.name]: Select,
        [Option.name]: Option,
        [Col.name]: Col
    },

    data() {
        return {
            selectedCategories: [], selectedServices: [], selectedItens: [], filterEmpty: 0, controllItems: [],
        };
    },

    watch: {
        resetFilter:{
            immediate: true,
            deep: true,
            handler: function(newValue, oldValue){
                if(newValue == false && oldValue == false){
                    this.fillOptionArrays()
                    this.$emit('rebootedFilter', false)
                }
            },
        },

        serviceOptionsToPreserve(newValue, oldValue){
            if(newValue.length == 0){ this.fillOptionArrays() }
        },

    },

    computed: {
        splittedServiceItems(){
            var items = Object.values(this.checkboxOptionsCategories)
            var partSize = Math.ceil(items.length / 4);

            let parte1 = items.slice(0, partSize);
            let parte2 = items.slice(partSize, 2 * partSize);
            let parte3 = items.slice(2 * partSize);
            return [parte1, parte2, parte3]
        },
    },

    methods: {
        selectedCategoriesChanged(category){
            let idx = this.selectedCategories.indexOf(category)
            let _selectedItensNames = []
            let _selectedCategories = []
            let _categoryCheck = false
            let _currentCategoryItems = this.controllItems[category]

            //Category is selected?
            if (idx >= 0) {
                _selectedCategories = this.selectedCategories
                _selectedCategories.splice(idx, 1)
                this.selectedCategories = _selectedCategories
            } 
            else {
                _categoryCheck = true
                this.selectedCategories.push(category)
            }

            //update checked property of all items from current category
            _currentCategoryItems.forEach((item) => {
                if (this.selectedServices.indexOf(item) >= 0) {
                    this.selectedItens[item] = _categoryCheck
                }
            })

            _selectedItensNames = Object.keys(this.selectedItens).filter(el => this.selectedItens[el])
            this.filterEmpty = _selectedItensNames.length
            this.$emit('selectedServices', _selectedItensNames)
        },

        selectedServicesChanged(service) {
            let _currentCategoryItems = this.controllItems[service.category]
            let _categoryHasItem = false
            
            _currentCategoryItems.forEach((item) => {
                if (this.selectedServices.indexOf(item) >= 0) {
                    _categoryHasItem = _categoryHasItem || this.selectedItens[item]
                }
            })
            
            let _selectedItensNames = Object.keys(this.selectedItens).filter(el => this.selectedItens[el])
            this.filterEmpty = _selectedItensNames.length
            this.$emit('selectedServices', _selectedItensNames)
        },

        fillOptionArrays(){
            let itemsList = {}
            let categories = []
            let _selectedItens = {}
            let _selectedServices = this.selectedServices
            let _controllItems = {}

            this.checkboxOptionsCategories.forEach((item, idx) => {
                let categoryName = item[0]
                let categoryItems = item[1]

                if (undefined == itemsList[categoryName]) {
                    categories.push(categoryName)
                    itemsList[categoryName] = []
                }
                
                categoryItems.forEach((categoryItem, idx) => {
                    itemsList[categoryName].push(categoryItem.service)
                    if (_selectedServices.indexOf(categoryItem.service) < 0) {
                        _selectedItens[categoryItem.service] = false
                    } 
                    else {
                        _selectedItens[categoryItem.service] = true
                    }
                })
            })

            this.selectedItens = _selectedItens
            this.selectedCategories = categories.sort()
            
            categories.forEach((cat) => {
                itemsList[cat].sort()
                _controllItems[cat] = itemsList[cat]
            })
            
            this.filterEmpty = Object.keys(_selectedServices).length
            this.controllItems = _controllItems
        },

    },

    mounted() {
        this.fillOptionArrays()

        if(this.serviceOptionsToPreserve.length > 0){
            var vm = this
            this.serviceOptionsToPreserve.map(function(value, index){
                if(vm.selectedItens.hasOwnProperty(value)){
                    vm.selectedItens[value] = true
                }
            })
        }
        else if(this.serviceOptionsToPreserve.length == 0){
            this.fillOptionArrays()
        }
    },
};
</script>
  